import { Injectable } from '@angular/core'
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
} from '@angular/router'
import { SessionService } from 'src/services/session-service'

@Injectable({providedIn: 'root'})
export class UserWriterGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private sessionService: SessionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.checkRole().then(role => {
        if (role && role === 'writer') {
          resolve(true)
        } else {
          if (window) window.location.pathname = '/'
          resolve(false)
        }
      })
    })
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state)
  }

  checkRole(): Promise<boolean | string> {
    return this.sessionService.currentRole()
  }
}
